import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// This module is kept for potential future use but services are provided in root
@NgModule({
  imports: [CommonModule],
})
export class ImpersonationModule {}
